import React, { useEffect, useState } from 'react';
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';
import axios from '../../axiosConfig';

export default function AbandonedRecoveryPage() {
  const navigate = useNavigate();
  const params = useParams();
  const [searchParams] = useSearchParams();
  const [error, setError] = useState('');

  useEffect(() => {
    let cancelled = false;

    const recoverCart = async () => {
      const recoveryId = params.id;
      const storeSlug = searchParams.get('store') || params.slug || '';

      if (!recoveryId || !storeSlug) {
        setError('This recovery link is invalid.');
        return;
      }

      try {
        await axios.post(`/cart/${encodeURIComponent(storeSlug)}/seed-from-abandoned/${encodeURIComponent(recoveryId)}`, {}, {
          withCredentials: true
        });

        if (cancelled) return;
        const isPathStorefront = window.location.pathname.startsWith('/s/');
        navigate(isPathStorefront ? `/s/${storeSlug}/checkout` : '/checkout', { replace: true });
      } catch (err) {
        if (cancelled) return;
        setError(err.response?.data?.error || 'We could not recover this cart.');
      }
    };

    recoverCart();
    return () => {
      cancelled = true;
    };
  }, [navigate, params.id, params.slug, searchParams]);

  return (
    <div style={{
      minHeight: '60vh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      padding: '32px'
    }}>
      <div style={{ textAlign: 'center', maxWidth: 420 }}>
        <h1 style={{ fontSize: 24, margin: '0 0 8px' }}>
          {error ? 'Recovery link unavailable' : 'Restoring your cart'}
        </h1>
        <p style={{ color: '#64748b', margin: 0 }}>
          {error || 'Please wait while we bring your items back to checkout.'}
        </p>
      </div>
    </div>
  );
}
